import { useMemo } from 'react';
import Typography from '@material-ui/core/Typography';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { DesignFileSearchResult } from '../../api-client/autogenerated';
import { Tooltip } from '@material-ui/core';
import { openFilesystemFileInNewTab } from '../../scripts/utils';
import { downloadFilesystemFile } from '../../models/api/filesystem';

const useStyles = makeStyles(() =>
  createStyles({
    documentItem: {
      padding: 16,
      paddingLeft: 47,
      border: '1px solid transparent',
      cursor: 'pointer',
      position: 'relative',
      '&:hover': {
        backgroundColor: '#F5F5F5',
      },
      '&::before': {
        content: '""',
        position: 'absolute',
        left: '24px',
        top: -2,
        bottom: 0,
        width: '2px',
        backgroundColor: '#0947B9',
      },
      '&::after': {
        content: '""',
        position: 'absolute',
        left: '24px',
        top: 24,
        width: '12px',
        height: '2px',
        backgroundColor: '#0947B9',
      },
      '&:last-child': {
        '&::before': {
          height: 28,
        },
      },
    },
    fileItem: {
      '&:hover': {
        backgroundColor: '#E0E0E0',
      },
    },
  }),
);

interface Props {
  designFile: DesignFileSearchResult;
  searchTerm: string;
  keywordSearchTerms: string[];
}

export default function DesignFileSearchItem(props: Props) {
  const { designFile, searchTerm } = props;
  const classes = useStyles();

  const downloadFile = async (
    projectId: string,
    name: string,
    fullKey: string,
    ownerId: string,
  ) => {
    await downloadFilesystemFile(projectId!, name, fullKey, false, ownerId);
  };

  const content = useMemo(() => {
    const isPdf = designFile.name.toLowerCase().endsWith('.pdf');

    const handleClick = () => {
      if (isPdf) {
        openFilesystemFileInNewTab(
          designFile.projectId,
          designFile.name,
          designFile.relativePath,
          designFile.ownerId,
          false,
          searchTerm,
        );
      } else {
        downloadFile(
          designFile.projectId,
          designFile.name,
          designFile.relativePath,
          designFile.ownerId,
        );
      }
    };

    return (
      <div key={designFile.id} onClick={handleClick} className={classes.documentItem}>
        <Typography style={{ fontSize: '16px', fontWeight: 600, marginBottom: 8 }}>
          {designFile.name}
        </Typography>
      </div>
    );
  }, [designFile, classes, searchTerm]);

  return (
    <Tooltip
      arrow
      title={
        designFile.name.toLowerCase().endsWith('.pdf')
          ? 'View Design File'
          : 'Click to download file'
      }
      placement="right-start"
    >
      {content}
    </Tooltip>
  );
}
